import { render, staticRenderFns } from "./form_download_page.vue?vue&type=template&id=7f045b5c"
import script from "./form_download_page.vue?vue&type=script&setup=true&lang=js"
export * from "./form_download_page.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports